import React from 'react';
import { Alert } from 'antd';
import { useHistory } from 'react-router-dom';

import { useCurrentSubscription, usePermission } from 'hooks';
import { Scope, SubscriptionStatus } from 'redux/reducers/authReducer';

export function PastDueBanner() {
  const subscription = useCurrentSubscription();
  const hasPermissionOrganizationSubscription = usePermission(Scope.OrganizationManageSubscription);
  const history = useHistory();

  if (subscription.status !== SubscriptionStatus.PastDue) {
    return <></>;
  }

  const buttonProps = {
    showIcon: true,
    onClick: () => history.push('/subscription'),
    className: 'cursor-pointer',
  };

  if (!hasPermissionOrganizationSubscription) {
    return <Alert {...buttonProps} type="warning" message={`Your account is now on read-only mode, please contact the owner.`} />;
  }

  return <Alert {...buttonProps} type="error" message={`We missed the payment for your subscription and your account is now on read-only mode, please click here to manage your subscription.`} />;
}
